import Api from '@/services/Api'

export default {
    getAllContratos(){
        return Api().get('contratos/getAll')
    },
    getContratoById(id){
        return Api().get('contratos/getContratoById/'+id)
    },
    getContratosByFechaInicio_FechaFin(fechaIni,FechaFin){
        return Api().get('contratos/getContratoByFechaInicioFechaFin/'+fechaIni+'/'+FechaFin)
    },
    createContrato(datos){
        return Api().post('contratos/create',datos)
    },
    leaContrato(numContrato){
        return Api().get('contratos/leaContrato/'+numContrato)
    },
    updateContrato(datos){
        return Api().put('contratos/update',datos)
    },
    terminarContrato(datos){
        return Api().put('contratos/terminarContrato',datos)
    }
}
